<template>
  <v-app style="background-color: white;">
    <div class="bckdiv">
      <v-container>
          <v-layout align-center justify-center style="margin-top:150px">
              <v-flex xs12 md8>
                <h1 class="white--text txt_my" style="text-align:center">ABOUT US</h1>
                <p class="white--text  mt-3" style="text-align:center">Your trusted trip companion</p>

              </v-flex>

             
                         </v-layout>
                         
              </v-container>
    </div>

    <v-container >
      <v-layout row wrap style="margin-top:50px;">
        

        <v-flex xs12 md5>
             <div class="about-us txt_my">
              <h1 class="txt_my">About Majumder Special</h1>
               <p class="mb-4 heading-2 txt_my">These popular destinations have a lot to offer</p>
                <p style="font-size: 14px;text-align: justify;" class="txt_my">Majumder Special (Established on 2004) is a package tour operator and Hotel Booking company.We organise Corporate tour, Forest tour, Office your, Pilgrimage tour, excurtion, carbooking and all india hotel booking. The best policy of Majumder Special is their honesty good will and best survices to the clients.There is no substitute of Majumder Special.</p>
            </div>
        </v-flex>
        <v-flex xs12 md1>
        </v-flex>
        <v-flex xs12 md6>
          <img class="about-us-img" src="../../assets/about.png" alt="">
        </v-flex>
 </v-layout>
    </v-container>
    
    <v-container max>

      
      <v-layout row wrap style="margin-top:50px;text-align: center;">
        
              <v-flex class="mb-3" xs12 md12 lg12>
                
                <div class="txt_my"> <h1 class="txt_my" style="text-align:center">Why Choose Us?</h1>
              <p class=" mt-3 txt_my" style="text-align:center">These popular destinations have a lot to offer</p></div>
              </v-flex>

              <v-flex xs12 md12>
                <div style="display: flex;align-items: center;justify-content: center;">
                <v-card style="text-align: center;margin: 10px;background-color: #FAF8ED;">
                  <div class="why-us-box">
                  <div class="why-us-img">
                    <img src="https://creativelayers.net/themes/gotrip-html/img/featureIcons/1/1.svg" alt="">
                </div>
                  <h4 class="txt_my">Best Price Guarantee</h4>
                </div>
                </v-card>

                <v-card style="text-align: center;margin: 10px;background-color: #FAF8ED;">
                  <div class="why-us-box">
                  <div class="why-us-img">
                    <img src="https://creativelayers.net/themes/gotrip-html/img/featureIcons/1/2.svg" alt="">
                </div>
                  <h4 class="txt_my">Easy & Quick Booking</h4>
                </div>
                </v-card>

                <v-card style="text-align: center;margin: 10px;background-color: #FAF8ED;">
                  <div class="why-us-box">
                  <div class="why-us-img">
                    <img src="https://creativelayers.net/themes/gotrip-html/img/featureIcons/1/3.svg" alt="">
                </div>
                  <h4 class="txt_my">Customer Care 24/7</h4>
                </div>
                </v-card>
      </div>
              </v-flex>
       </v-layout>


    </v-container>

    <div style="background-color: #F78163;color: white;padding-top: 30px;padding-bottom: 50px;">
      <v-container>
        <v-layout wrap>
          <v-flex xs12 sm12 md6 lg6 style="padding-right: 10px;">
            <h1 class="txt_my"><span class="txt_my" style="border-bottom: 5px solid;border-radius: 5px;">HE</span>AD OFFICE</h1>
            <p class="txt_my" style="padding-top: 25px;">275, criper road, Dist: Hooghly, Konnagar<br/> Dream apt.
              1st floor ( Opposite IDBI Bank ) Pin-712235</p>
              <p class="txt_my">Working Days: Friday - Wednesday (11 AM - 9 PM)</p>
              <p class="txt_my" style="font-size: 20px;">033-2674-0229 | +91 8240495872</p>
              <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3680.7172426720203!2d88.34374857398953!3d22.701567628233708!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f89c9edac5e7a7%3A0x57a8cbfbc0b80c9d!2sMajumder%20Special!5e0!3m2!1sen!2sin!4v1718862744935!5m2!1sen!2sin"
        width="100%"
        height="200"
        style="border:0;"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
          </v-flex>

          <v-flex xs12 sm12 md6 lg6 style="padding-left: 10px;">
            <h1 class="txt_my"><span class="txt_my" style="border-bottom: 5px solid;border-radius: 5px;">CI</span>TY OFFICE</h1>
            <p class="txt_my" style="padding-top: 25px;">1 R. N. Mukharjee Road, Shop No: 19, Ground Floor<br/> Opp Lal Bazar, Martinburn Building, Kolkata-700001</p>
            <p class="txt_my">Working Days: Monday - Saturday (10 AM - 7 PM)</p>  
            <p class="txt_my" style="font-size: 20px;"> +91 9433319675 </p>
              <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3680.7172426720203!2d88.34374857398953!3d22.701567628233708!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f89c9edac5e7a7%3A0x57a8cbfbc0b80c9d!2sMajumder%20Special!5e0!3m2!1sen!2sin!4v1718862744935!5m2!1sen!2sin"
        width="100%"
        height="200"
        style="border:0;"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <v-container style="padding-top: 70px;">
      <iframe width="100%" height="385" src="https://www.youtube.com/embed/fDC6mAFLtx8" title="Majumder Special Tour &amp; Travells Testimonials" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </v-container>
    
    <!-- <div >
       <v-container  style="max-width: 1400px;border-bottom: 1px solid #DDDDDD;">
        <v-layout row wrap>
          <v-flex xs12 md3 sm12 style="padding:20px" >
               <div class="box" >
                   <h1>4,958</h1>
                   <p>Destinations</p>
               </div>
          </v-flex>
          <v-flex xs12 md3 sm12 style="padding:20px" >
               <div class="box" >
                   <h1>2,869</h1>
                   <p>Total Properties</p>
               </div>
          </v-flex>
          <v-flex xs12 md3 sm12 style="padding:20px" >
               <div class="box" >
                   <h1>2M</h1>
                   <p>Happy customers</p>
               </div>
          </v-flex>
          <v-flex xs12 md3 sm12 style="padding:20px" >
               <div class="box" >
                   <h1>574,974</h1>
                   <p>Our Volunteers</p>
               </div>
          </v-flex>
        </v-layout>
       </v-container>
     </div> -->


    </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
    };
  },
  
};
</script>

<style scoped>
@import '../../HomeCss/home.css';

@import url("https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap");
@import url("https://fonts.googleapis.com/css?family=Anton&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Alice&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Josefin+Slab:ital,wght@0,100..700;1,100..700&display=swap");
</style>

<style scoped>
  v-app {
    font-family: 'Jost', sans-serif!important;

  }
  .txt_my {
  font-family: "Alice", serif !important;
}
.bgclr {
    width: 100%;
    height: 350px;
    background-image: linear-gradient(#7b1fa2, #e91e63);
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.txtcntr {
  text-align: center;
}
.mrgn {
  margin-top: 50px;
}
h1.heading_1 {
  width: 100% !important;
}

.bg_clr {
  background-color: grey;
}

.heading_1 {
  font-family: 'Space Mono', monospace;
  text-align: center !important;
}
.main_icon {
  text-align: center !important;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.why-us-img img{
 max-width: 100%;
 max-height: 100%;
 margin-bottom: 25px;
}
.about-us-img {
  max-width: 100%;
  border-radius: 5px;
}
.about-us {
  padding: 15px;
}
.about-us .heading-2 {
 
  color: #697488;

}
.why-us-box {
  padding:20px 50px;
}
.why-us p,.why-us-box p {
  color: #697488;
}
.box {
text-align: center;
}
.box h1 {
  color: #051036;
  font-weight: bold;
}
.box p {
  color: #697488;
}
.team-card {
  color:#051036;
}
.team-card img {
  height: 200px;
  width: 200px;
  border-radius: 5px;
  margin-bottom: 15px;
}
.hotel_name {
  font-family: 'Space Mono', monospace;
  font-weight: bold;
}
.enquiry {
    font-family: 'Bree Serif', serif;
}
.contact_tag {
    font-family: 'Space Mono', monospace;
}
.bckdiv {
    background-image: url("../../assets/aboutus.jpg");
    height: 400px;
    background-size: cover;
}
@media screen and (max-width: 763px) {
  .rspnsv {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    background-position: center;
    background-size: cover;
  }
  .team-card {
    text-align: center;
  }
  .help {
    padding-right: 0px !important;
  }
  .aboutTop {
      margin-top: 180px;
      margin-bottom: 100px;
  }
}
@media screen and (min-width: 768px){
  .xyz {
      height: 625px;
  }
}
</style>
